import { useNavigate, useLocation } from "react-router-dom";
import { OnboardingLayout } from "./OnboardingLayout";
import { startGoogleSignIn } from "@/services/google";
import { trackConnectEmailViewed, trackEmailProviderClicked } from "@/services/analytics";
import { useEffect } from "react";
import styles from "./Onboarding.module.css";
import { startAppleSignIn } from "@/services/apple";

import AppleLogo from "@/assets/appleLogo";

const EmailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none">
    <path
      d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
      fill="currentColor"
    />
  </svg>
);

export function ConnectEmail() {
  const navigate = useNavigate();
  const location = useLocation();
  const cameFromLogin = (location.state as { from?: string })?.from === "login";

  useEffect(() => {
    trackConnectEmailViewed(cameFromLogin ? "login" : "signup");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function handleGmail() {
    trackEmailProviderClicked("gmail");
    startGoogleSignIn();
  }

  async function handleApple() {
    trackEmailProviderClicked("apple");
    startAppleSignIn();
  }

  function handleComingSoonProvider(provider: string) {
    trackEmailProviderClicked(provider);
    navigate("/coming-soon");
  }

  return (
    <OnboardingLayout currentStep={3} totalSteps={4}>
      <h2 className={styles.stepTitle}>Connect your email</h2>
      <p className={styles.stepDescription}>
        Closai scans digital receipts to automatically catalog your purchases. We pinpoint purchase order information
        from trusted brands and retailers — nothing else. Your data stays private and secure.
      </p>

      <div className={styles.emailOptions}>
        <button className={[styles.emailBtn, styles.emailBtnGmail].join(" ")} onClick={handleGmail}>
          <EmailIcon />
          Continue with Gmail
          <span className={styles.recommendedBadge}>Recommended</span>
        </button>
        <button className={[styles.emailBtn].join(" ")} onClick={handleApple}>
          <AppleLogo />
          Continue with Apple
        </button>

        <button className={[styles.emailBtn].join(" ")} onClick={() => navigate("/email-password")}>
          Continue with Email and Password
        </button>

        <div className={styles.emailAltGrid}>
          <button className={styles.emailBtnSmall} onClick={() => handleComingSoonProvider("outlook")}>
            <EmailIcon />
            Outlook
          </button>
          <button className={styles.emailBtnSmall} onClick={() => handleComingSoonProvider("yahoo")}>
            <EmailIcon />
            Yahoo
          </button>
          <button className={styles.emailBtnSmall} onClick={() => handleComingSoonProvider("icloud")}>
            <EmailIcon />
            iCloud
          </button>
          <button className={styles.emailBtnSmall} onClick={() => handleComingSoonProvider("other")}>
            <EmailIcon />
            Other
          </button>
        </div>
      </div>

      <button className={styles.skipLink} onClick={() => navigate(cameFromLogin ? "/onboarding" : "/departments")}>
        ← Go back
      </button>
    </OnboardingLayout>
  );
}
